import { connect } from 'react-redux';
import FollowCallAppointment from '../components/Questionnaire/pages/FollowCallAppointment';
import { push } from "react-router-redux";
import { getUser } from '../redux/actions/AccountSetting';
import { getTimelineStatusById } from '../redux/actions/Timeline';
import * as actions from '../redux/actions/FollowCallAppointment';

const mapStateToProps = (state) => {
  return {
    user: state.accountSetting.user,
    isLoadingUser: state.accountSetting.isLoading,
    timelineStatus: state.timeline.timelineStatus,
    isLoadingStatuses: state.timeline.isLoadingStatuses,
    isSaving: state.followCallAppointment.isSaving,
    error: state.followCallAppointment.error,
  };
};

const mapDispatchToProps = dispatch => ({
  getUserInfo() {
    dispatch(getUser());
  },

  goToDashboard() {
    dispatch(push('/'));
  },

  postFollowCallAppointment(id, data) {
    dispatch(actions.postFollowCallAppointment(id, data));
  },

  getTimelineStatusById(id) {
    dispatch(getTimelineStatusById(id));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(FollowCallAppointment);



// WEBPACK FOOTER //
// ./src/containers/FollowCallAppointment.js